export const hideSpinner = () => {
  const spinners = document.getElementsByClassName('guidion-spinner');

  if (spinners.length > 0) {
    document.body.removeChild(spinners[0]);
  }
};
